export default "__VITE_ASSET__CdTOBu4n__"